import React from 'react';
import { AlertTriangle } from 'lucide-react';
import TierBadge from '@components/common/TierBadge';
import Tooltip from '@components/common/Tooltip';
import { ScheduleItem } from '@app-types';
import { tierToVariant } from '@utils/badgeMappers';
import styles from './SchedulerTableCells.module.css';

const GroupTierBadges: React.FC<{
  scheduleItem: ScheduleItem;
  tier: string;
  hasBundleTierConflict: boolean;
}> = ({ scheduleItem, tier, hasBundleTierConflict }) => {
  const uniqueTiers = Array.from(new Set(scheduleItem.contracts.map((c) => c.tier)));

  if (uniqueTiers.length > 1) {
    // Multiple different tiers - show all tiers + warning icon
    return (
      <div className={styles.tierCellWrapper}>
        <div className={styles.tierBadgesGroup}>
          {uniqueTiers.map((tierName) => (
            <TierBadge key={`tier-${tierName}`} variant={tierToVariant(tierName)}>
              {tierName}
            </TierBadge>
          ))}
        </div>
        {hasBundleTierConflict && (
          <Tooltip content="Tier conflict" position="top" variant="error">
            <span className={styles.conflictWarningIcon}>
              <AlertTriangle size={16} />
            </span>
          </Tooltip>
        )}
      </div>
    );
  }

  // Single tier - show one tier badge
  return <TierBadge variant={tierToVariant(tier)}>{tier}</TierBadge>;
};

export default GroupTierBadges;
